<template>
  <form-wrap
    class="destroy-account-settings"
    @submit="handleDestroy"
  >
    <section-title v-t="'p.destroyProfileSettings.title'"/>
    <form-field-set>
      <text-input
        v-model="currentPassword"
        :error="fieldError('destroy', 'currentPassword')"
        :label="$t('p.destroyProfileSettings.form.label.currentPassword')"
        name="currentPassword"
        type="password"
      />
    </form-field-set>
    <form-actions>
      <button-input
        v-t="'p.destroyProfileSettings.form.action.submit'"
        color="error"
        type="submit"
      />
    </form-actions>
  </form-wrap>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'DestroyAccountSettings',
  mixins: [FormMixin, PageMixin],
  computed: {
    ...mapGetters({
      currentUserId: 'currentUserId',
      fieldError: 'destroyAccountForm/fieldError'
    }),
    currentPassword: {
      get () { return this.$store.state.destroyAccountForm.form.currentPassword },
      set (value) { this.$store.dispatch('destroyAccountForm/setCurrentPassword', value) }
    }
  },
  methods: {
    ...mapActions({
      destroy: 'destroyAccountForm/destroy',
      loadingDone: 'app/loadingDone',
      signOut: 'signOut'
    }),
    handleDestroy () {
      this.destroy({ userId: this.currentUserId })
        .then(() => {
          this.signOut()
        })
        .catch(() => {})
    }
  },
  created () {
    this.loadingDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/DestroyProfileSettings.vue